// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2XqFC","card":"Cards_card__1ak5A","confirmed":"Cards_confirmed__3xta-","recovered":"Cards_recovered__1wTBM","deaths":"Cards_deaths__1YvrA"};